import type { WhatsAppInboxMessage } from '@zrsystem/contracts';

import { isWhatsAppGroupChat } from '@/features/notification/lib/whatsapp-inbox-chat-kind.js';

/**
 * Derives WAHA chat id from an inbound/outbound message payload.
 * GOWS direct chats put the conversation id in `from` and leave `to` empty.
 * NOWEB outbound puts the peer in `to`.
 */
export function resolveWhatsAppInboxChatId(message: WhatsAppInboxMessage): string {
  if (isWhatsAppGroupChat(message.from)) {
    return message.from;
  }
  if (isWhatsAppGroupChat(message.to)) {
    return message.to;
  }
  if (message.fromMe && message.to.includes('@')) {
    return message.to;
  }
  return message.from;
}
